import { AppBar, Toolbar, Typography, Button, Box, Container } from '@mui/material';
import { School, Login } from '@mui/icons-material';

interface HeaderProps {
  onLoginClick?: () => void;
}

const Header = ({ onLoginClick }: HeaderProps) => {
  const handleLogin = () => {
    // Redirect to admin portal login
    window.location.href = 'https://admin-aims.amy.care/login';
  };

  return (
    <AppBar 
      position="sticky" 
      sx={{ 
        background: 'linear-gradient(135deg, #A5D6A7 0%, #81C784 100%)',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      }}
    >
      <Container maxWidth="xl">
        <Toolbar sx={{ justifyContent: 'space-between', py: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <School sx={{ fontSize: 40, color: 'white' }} />
            <Box>
              <Typography 
                variant="h5" 
                component="div" 
                sx={{ 
                  fontWeight: 700, 
                  color: 'white',
                  letterSpacing: 0.5,
                }}
              >
                ระบบศิษย์เก่า คณะพยาบาลศาสตร์
              </Typography>
              <Typography 
                variant="caption" 
                sx={{ 
                  color: 'rgba(255,255,255,0.9)',
                  fontSize: '0.875rem',
                }}
              >
                มหาวิทยาลัยราชภัฏสุราษฎร์ธานี
              </Typography>
            </Box>
          </Box>
          
          <Button 
            variant="contained" 
            startIcon={<Login />}
            onClick={onLoginClick || handleLogin}
            sx={{ 
              backgroundColor: 'white',
              color: 'primary.dark',
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.9)',
              },
              fontWeight: 600,
              px: 3,
            }}
          >
            เข้าสู่ระบบ
          </Button>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
